import { render, staticRenderFns } from "./EducationItem.vue?vue&type=template&id=5b8fff0d&scoped=true"
import script from "./EducationItem.vue?vue&type=script&lang=js"
export * from "./EducationItem.vue?vue&type=script&lang=js"
import style0 from "./EducationItem.vue?vue&type=style&index=0&id=5b8fff0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8fff0d",
  null
  
)

export default component.exports